














































import Vue from 'vue'
import {
  DxGantt,
  DxColumn,
  DxDependencies,
  DxResourceAssignments,
  DxResources,
  DxTasks, DxFilterRow, DxContextMenu
} from 'devextreme-vue/gantt'
import 'devexpress-gantt/dist/dx-gantt.min.css'
import 'devexpress-gantt/dist/dx-gantt.min'
import deMessages from "devextreme/localization/messages/de.json"
import frMessages from "devextreme/localization/messages/fr.json"
import itMessages from "devextreme/localization/messages/it.json"
import { locale, loadMessages } from "devextreme/localization"
import moment from 'moment'
import { GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'
import { ProjectDetail } from '@/model/project/ProjectDetail'
import { GET_PROJECT_DETAIL_ABLAUF } from '@/store/action-types'
import { SnackbarStateEnum } from '@/types/enums'
import { TranslateResult } from 'vue-i18n'
import ProgressCircular from '@/components/ProgressCircular.vue'
import GanttDetailDialog from '@/components/project/GanttDetailDialog.vue'

interface ComponentData {
  showSnackbar: boolean
  snackbarState: number
  messageSnackbar: TranslateResult | string
  loading: boolean
  taskList: any[]
  dependencies: any[]
  resources: any[]
  resourceAssignments: any[]

  startDateRange: Date | null
  endDateRange: Date | null

  showGanttDetailDialog: boolean
  dialogData: any | null
  employeeList: any[]
  ganttWidth: number
}

export default Vue.extend({
  name: 'TicketingProcessGantt',

  components: {
    ProgressCircular,
    GanttDetailDialog,
    DxGantt,
    DxTasks,
    DxDependencies,
    DxResources,
    DxResourceAssignments,
    DxColumn,
    DxFilterRow,
    DxContextMenu
  },

  props: {
    ganttHeight: String,
    step: Object as () => any
  },

  data (): ComponentData {
    return {
      showSnackbar: false,
      snackbarState: 0,
      messageSnackbar: '',
      loading: false,
      taskList: [],
      dependencies: [],
      resources: [],
      resourceAssignments: [],

      startDateRange: null,
      endDateRange: null,

      showGanttDetailDialog: false,
      dialogData: null,
      employeeList: [],
      ganttWidth: 1000
    }
  },

  watch: {
    projectDetail (newVal: ProjectDetail): void {
      if(newVal) {
        this.fetchData()
      }
    }
  },

  computed: {
    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    },

    selectedLanguageCode (): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    }
  },

  methods: {
    formatDate(item: Date): string {
      return moment(item).isValid() ? moment(item).format('DD.MM.YYYY') : ''
    },

    onContextMenuPreparing (e: any) {
      e.cancel = true
    },

    onCustomCommandClick(e: any) {
      /*if (e.name === 'DELETE') {
        console.log('delete')
      } else if(e.name === 'EDIT') {
        this.dialogData = {}
        this.showGanttDetailDialog = true
      }*/
    },

    taskDblClick(e: any): void {
      e.cancel = true
      const foundTask: any | undefined = this.taskList.find((item: any) => item.id == e.key)
      if(foundTask && foundTask.parentId) {
        this.dialogData = foundTask
        this.showGanttDetailDialog = true
      }
    },

    onCloseGanttDetailDialog(): void {
      this.showGanttDetailDialog = false
    },

    async fetchData (): Promise<void> {
      try {
        this.loading = true
        this.dependencies = []

        const response: any = await this.$store.dispatch(GET_PROJECT_DETAIL_ABLAUF, 639196)
        this.loading = false
        if (!response.IsError && response.Data) {

          this.employeeList = response.Data.ds03

          this.taskList = response.Data.ds01.map((item: any) => {
            const filteredSchritt: any[] = response.Data.ds07.filter((i: any) => i.ProzessArt === item.ID)
            const foundFirstDetail: any | undefined = filteredSchritt[0] ? response.Data.ds08.find((i: any) => i.Schritt === filteredSchritt[0].Schritt) : undefined
            const foundLastDetail: any | undefined = filteredSchritt[filteredSchritt.length - 1] ? response.Data.ds08.find((i: any) => i.Schritt === filteredSchritt[filteredSchritt.length - 1].Schritt) : undefined
            this.startDateRange = foundFirstDetail && foundFirstDetail.DatumSoll ? moment(foundFirstDetail.DatumSoll).subtract(1, 'day').startOf('day').toDate() : moment().subtract(1, 'day').startOf('day').toDate()
            this.endDateRange = foundLastDetail && foundLastDetail.DatumIst ? moment(foundLastDetail.DatumIst).add(1, 'day').endOf('day').toDate() : foundLastDetail && foundLastDetail.DatumSoll ? moment(foundLastDetail.DatumSoll).add(1, 'day').endOf('day').toDate() : moment().add(1, 'day').endOf('day').toDate()
            return {
              id: item.ID,
              parentId: null,
              title: item.Bezeichnung,
              start: foundFirstDetail && foundFirstDetail.DatumSoll ? moment(foundFirstDetail.DatumSoll).toDate() : null,
              end: foundLastDetail && foundLastDetail.DatumIst ? moment(foundLastDetail.DatumIst).toDate() : null,
              mitarbeiterSoll: null,
              mitarbeiterIst: null,
              adressLinie: null,
              progress: 0
            }
          })

          response.Data.ds07.forEach((item: any, index: number) => {
            const foundDetail: any | undefined = response.Data.ds08.find((i: any) => i.Schritt === item.Schritt)
            const foundMitarbeiterSoll: any | undefined = foundDetail ? response.Data.ds03.find((i: any) => i.ID === foundDetail.MitarbeiterSoll) : undefined
            const foundMitarbeiterIst: any | undefined = foundDetail ? response.Data.ds03.find((i: any) => i.ID === foundDetail.MitarbeiterIst) : undefined
            //const foundAddress: any | undefined = response.Data.ds10.find((i: any) => i.ID === item.MitarbeiterIst)

            this.taskList.push({
              id: item.ID,
              parentId: item.ProzessArt,
              title: item.SchrittBezeichnung,
              start: foundDetail && foundDetail.DatumSoll ? moment(foundDetail.DatumSoll).startOf('day').toDate() : null,
              end: foundDetail && foundDetail.DatumSoll ? moment(foundDetail.DatumSoll).endOf('day').toDate() : null,//foundDetail && foundDetail.DatumIst ? moment(foundDetail.DatumIst).endOf('day').toDate() : foundDetail && foundDetail.DatumSoll ? moment(foundDetail.DatumSoll).endOf('day').toDate() : null,
              datumIst: foundDetail && foundDetail.DatumIst ? moment(foundDetail.DatumIst).endOf('day').toDate() : null,
              mitarbeiterSoll: foundMitarbeiterSoll && foundMitarbeiterSoll.VollerName ? foundMitarbeiterSoll.VollerName : '',
              mitarbeiterIst: foundMitarbeiterIst && foundMitarbeiterIst.VollerName ? foundMitarbeiterIst.VollerName : '',
              adressLinie: foundDetail && foundDetail.AdressLinie ? foundDetail.AdressLinie : '',
              progress: foundDetail && foundDetail.DatumIst ? 100 : 0,
              employeeFrom: foundMitarbeiterSoll && foundMitarbeiterSoll.ID ? foundMitarbeiterSoll.ID : null,
              employeeTo: foundMitarbeiterIst && foundMitarbeiterIst.ID ? foundMitarbeiterIst.ID : null,
              addressId: foundDetail && foundDetail.Adresse ? foundDetail.Adresse : null,
              genAdresse: foundDetail && foundDetail.GenAdresse ? foundDetail.GenAdresse : null,
              amount: foundDetail && foundDetail.Menge ? foundDetail.Menge : null,
              belegNumber: foundDetail && foundDetail.Belegnummer ? foundDetail.Belegnummer : null,
            })

            if(index > 0 && response.Data.ds07[index - 1]) {
              this.dependencies.push({
                id: index,
                predecessorId: response.Data.ds07[index - 1].ID,
                successorId: item.ID,
                type: 0,
              })
            }

          })

        } else {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.loading = false
        this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    }
  },

  created (): void {
    loadMessages(deMessages)
    loadMessages(frMessages)
    loadMessages(itMessages)
    locale(this.selectedLanguageCode)
  },

  mounted () {
    if(window && window.innerWidth) {
      this.ganttWidth = window.innerWidth * 0.8
    }
    this.fetchData()
  }
})
